const rules = {
  'ese.required.field': 'ese.required.field',
  'ese.required.item': 'ese.required.item',
}

const esJSON = {
  'ese.login': 'Login',
  'ese.logout': 'Logout',
  'ese.home': 'Home',
  'ese.system.application.center': 'System Application Center',
  'ese.faqs': 'FAQS',
  'ese.feedback': 'Feedback',

  ...rules,
};

export default esJSON;
